export const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  audience: import.meta.env.VITE_AUTH0_AUDIENCE,
  scope: "openid email profile offline_access",
  redirectUri: window.location.origin,
  cacheLocation: "localstorage" as const,
  useRefreshTokens: true,
  // Only rewrite history when we have a fresh `returnTo` from a real login /
  // deep-link round-trip. Silent token refresh fires this callback with no
  // appState — falling back to `/triage` here used to clobber the operator's
  // current URL (mid-session bounce to `/triage?…&issue=8`, deep-link drops,
  // back/forward collapse). When there's nothing to restore, leave the URL
  // alone.
  onRedirectCallback: (appState: any) => {
    if (appState && appState.returnTo) {
      window.history.replaceState({}, document.title, appState.returnTo);
    }
  },
};

export const isAuth0Configured = () => {
  return !!(auth0Config.domain && auth0Config.clientId);
};

export const getAuth0ConfigError = (): string | null => {
  const missing: string[] = [];
  if (!auth0Config.domain) missing.push('VITE_AUTH0_DOMAIN');
  if (!auth0Config.clientId) missing.push('VITE_AUTH0_CLIENT_ID');
  if (missing.length > 0) {
    return `Missing Auth0 configuration: ${missing.join(', ')}`;
  }
  return null;
};
